module.exports = __webpack_public_path__ + "static/media/points8_6.1cf375c3.png";